export default defineNuxtRouteMiddleware(async (to, from) => {
  const token = (to.query?.token as string) || (to.redirectedFrom?.query?.token as string)
  if (token) return
  if (to.name === 'VideoCallExternal') return
  if (to.name === 'mobile') return

  try {
    const userStore = useUserStore()
    //if (userStore.token) userStore.loadPolicies()
  } catch (error) {
    console.error('failed to preload ressources')
  }
})
